var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#1ab394",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.47135 7.78575c.17489-.1534.45348-.14889.62225.01007.81471.76736 1.8672 1.29099 3.0174 1.50121 1.1502.21021 2.3436.09703 3.4213-.32448.2233-.08732.4821.0064.5782.20932s-.007.43821-.2303.52553c-1.2419.4857-2.6172.6162-3.9427.3739-1.3255-.24222-2.53836-.84565-3.47723-1.72995-.16877-.15897-.16381-.41219.01108-.5656z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 6.79999c-1.8228 0-3.30051 1.34314-3.30051 2.99998 0 1.65683 1.47771 2.99993 3.30051 2.99993s3.3005-1.3431 3.3005-2.99993c0-1.65684-1.4777-2.99998-3.3005-2.99998zm-4.18065 2.99998c0-2.09867 1.87174-3.79997 4.18065-3.79997 2.3089 0 4.1807 1.7013 4.1807 3.79997 0 2.09863-1.8718 3.79993-4.1807 3.79993-2.30891 0-4.18065-1.7013-4.18065-3.79993z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.47419 14.9292c1.05471-.607 2.27741-.9293 3.52581-.9293s2.4711.3223 3.5258.9293c1.0547.6071 1.8981 1.4739 2.4318 2.4997.104.1997.0101.4381-.2096.5326s-.4821.0091-.586-.1906c-.4625-.8887-1.1932-1.6398-2.107-2.1658-.9139-.526-1.9733-.8052-3.055-.8052s-2.14109.2792-3.05495.8052-1.64457 1.2771-2.10707 2.1658c-.10392.1997-.36627.2851-.58597.1906-.21971-.0945-.31357-.3329-.20965-.5326.53378-1.0258 1.37711-1.8926 2.43183-2.4997z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.5d858070de4236540d5f5b4da20c20d0.svg";
export { ForwardRef as ReactComponent };